import {
  UseMutationOptions,
  UseQueryOptions,
  queryOptions,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import {
  ResponseError,
  ResultOfAccessResponseViewModel,
  ResultOfActingAsResponseViewModel,
  ResultOfBoolean,
  ResultOfListOfIntermediaryAssociatesViewModel,
  SecurityActingAsRequest,
  SecurityGetAccessRequest,
  SecurityGetIntermediaryAssociatesInformationRequest,
  SecurityUnlockSiteRequest,
  useApiClient
} from 'bff';

export const getAccessOptions = () => {
  const { securityApi } = useApiClient();
  return queryOptions({
    queryKey: ['useGetAccess'] as const,
    queryFn: () => securityApi.securityGetAccess(),
    select: (data) => data.data!,
    staleTime: Infinity
  });
};

export const useSearchForIntermediary = (
  options?: UseMutationOptions<
    ResultOfAccessResponseViewModel,
    ResponseError,
    SecurityGetAccessRequest
  >
) => {
  const { securityApi } = useApiClient();
  const mutationOptions: typeof options = {
    ...options,
    mutationKey: ['useGetAccess'],
    mutationFn: (requestParameters) => securityApi.securityGetAccess(requestParameters)
  };
  return useMutation(mutationOptions);
};

export const useGetActingAs = (
  options?: UseMutationOptions<
    ResultOfActingAsResponseViewModel,
    ResponseError,
    SecurityActingAsRequest
  >
) => {
  const { securityApi } = useApiClient();

  const mutationOptions: typeof options = {
    ...options,
    mutationKey: ['useGetActingAs'],
    mutationFn: (securityActingAsRequest) => securityApi.securityActingAs(securityActingAsRequest),
    onSuccess: (...args) => {
      if (options?.onSuccess) {
        options.onSuccess(...args);
      }
    }
  };

  return useMutation(mutationOptions);
};

export const useValidateSitePassword = (
  options?: UseMutationOptions<ResultOfBoolean, ResponseError, SecurityUnlockSiteRequest>
) => {
  const { securityApi } = useApiClient();
  const mutationOptions: typeof options = {
    ...options,
    mutationKey: ['useValidateSitePassword'],
    mutationFn: (request) => securityApi.securityUnlockSite(request),
    onSuccess: (...args) => {
      if (options?.onSuccess) {
        options.onSuccess(...args);
      }
    }
  };
  return useMutation(mutationOptions);
};

export const useGetIntermediaryAssociatesInformation = (
  requestparameters: SecurityGetIntermediaryAssociatesInformationRequest,
  options?: UseQueryOptions<ResultOfListOfIntermediaryAssociatesViewModel, ResponseError>
) => {
  const { securityApi } = useApiClient();

  const queryoptions: UseQueryOptions<
    ResultOfListOfIntermediaryAssociatesViewModel,
    ResponseError
  > = {
    ...options,
    queryKey: ['useGetIntermediaryAssociatesInformation', requestparameters],
    queryFn: () => securityApi.securityGetIntermediaryAssociatesInformation(requestparameters)
  };

  return useQuery(queryoptions);
};
